import { Component } from "react";
import { AlertTriangle } from "lucide-react";

// Red de seguridad del MODO DEMO: si una pantalla falla en vivo (un fixture al que le
// falta un campo), la demostración muestra un mensaje honesto en vez de una página en
// blanco. Solo se monta en el build demo.
export class LimiteDeErrorDemo extends Component {
  constructor(props) {
    super(props);
    this.state = { fallo: null };
  }

  static getDerivedStateFromError(error) {
    return { fallo: error };
  }

  componentDidCatch(error, info) {
    // Queda en consola para que el equipo pueda corregir el fixture que falta.
    console.error("[demo] pantalla no disponible:", error, info?.componentStack);
  }

  render() {
    if (!this.state.fallo) return this.props.children;
    return (
      <div data-testid="demo-pantalla-no-disponible"
        className="flex min-h-[70vh] flex-col items-center justify-center gap-3 p-10 text-center">
        <AlertTriangle className="h-10 w-10 text-amber-500" strokeWidth={1.5} />
        <h2 className="font-heading text-lg font-semibold text-slate-700">
          Esta pantalla no está incluida en la demostración
        </h2>
        <p className="max-w-md text-sm text-slate-500">
          El entorno de demostración cubre el tablero, clientes y expedientes, cumplimiento PLD,
          cartera y cobranza. En el entorno real esta vista opera con los datos de tu entidad.
        </p>
        <button
          data-testid="demo-volver-tablero"
          onClick={() => { window.location.href = "/dashboard"; }}
          className="mt-1 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:opacity-90">
          Volver al tablero
        </button>
      </div>
    );
  }
}

export default LimiteDeErrorDemo;
